/* eslint-disable max-params */

import { vector, Vector2D } from '../Vector2D/vector2d'
import { Move, Pose } from '../SvgHelper/tracer'

type Options = {
  radius: number
  spacing: number
  marginHorizontal: number
  marginVertical: number
}

function leftEdge(pose: Pose, options: Options) {
  const { position, direction } = pose
  const left = Vector2D.rotate(direction, -Math.PI / 2)
  return getCoordinates(position, left, options)
}

function getCoordinates(position: vector, edgeOffset: vector, options: Options) {
  const { radius, spacing, marginHorizontal, marginVertical } = options
  const columnWidth = 2 * radius + spacing
  const x = radius + marginHorizontal + columnWidth * position[0] + edgeOffset[0] * radius
  const y = radius + marginVertical + columnWidth * position[1] + edgeOffset[1] * radius
  return [x, y]
}

export function toPath(moves: Array<Move>, options: Options): string {
  const { radius, spacing } = options
  const start = leftEdge(moves[0].from, options)
  return [
    `M ${start[0]} ${start[1]}`,
    ...moves.map(move => {
      if (move.type === 'forward' || move.type === 'two forward') {
        const to = leftEdge(move.to, options)
        return `L ${to[0]} ${to[1]}`
      } else if (move.type === 'rotate right') {
        const to = leftEdge(move.to, options)
        return `A ${radius} ${radius} 0 0 1 ${to[0]} ${to[1]}`
      } else if (move.type === 'diagonal left') {
        const to = leftEdge(move.to, options)
        return `A ${radius + spacing} ${radius + spacing} 0 0 0 ${to[0]} ${to[1]}`
      }

      throw new Error('Unknown move')
    }),
    'Z'
  ].join(' ')
}
